import { createFileRoute, notFound } from "@tanstack/react-router";
import { getAboutUs } from "@/lib/server-functions";
import AboutPage from "@/pages/About";
import ogImage from "@/assets/knmc-og.jpeg";
import { getPageUrl } from "@/lib/site";
import { aboutJsonLd } from "@/lib/jsonld";

export const Route = createFileRoute("/about")({
  loader: async () => {
    try {
      const aboutUs = await getAboutUs();
      return { aboutUs };
    } catch {
      throw notFound();
    }
  },

  head: () => {
    const pageUrl = getPageUrl("/about");

    return {
      meta: [
        {
          title: "About KNMC — Top Medical College in Kathmandu, Nepal",
        },
        {
          name: "description",
          content:
            "Learn about KNMC, a leading teaching hospital and medical college in Kathmandu, Nepal — mission, leadership, and world-class healthcare.",
        },
        {
          name: "keywords",
          content:
            "medical college Kathmandu, teaching hospital Nepal, KNMC about, healthcare Kathmandu",
        },
        {
          property: "og:title",
          content: "About KNMC — Kathmandu, Nepal",
        },
        {
          property: "og:description",
          content:
            "Compassionate care and advanced medicine at Nepal's leading teaching hospital in Kathmandu.",
        },
        {
          property: "og:image",
          content: getPageUrl(ogImage),
        },
        {
          property: "og:url",
          content: pageUrl,
        },
        aboutJsonLd(),
      ],

      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: () => {
    const { aboutUs } = Route.useLoaderData();
    return <AboutPage aboutUs={aboutUs} />;
  },
});